'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserPackage() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_USER_PACKAGE);
}

exports.default = getUserPackage;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/cookie/getUserPackage.js
// module id = 151
// module chunks = 0